import NwRouter from './router';
import NwLang from './lang';
import NwFx from './fx';


/**
 * Classe che configura e avvia tutti i componenti della webapp
 */
export default class NwApp {
    constructor() {
        this.config = {};
        this.components = {};
        this.router = new NwRouter();
        this.lang = new NwLang();
        this.fx = new NwFx();
    }

    /**
     * Avvia l'esecuzione della webapp
     * @param conf (Object): Oggetto di configurazione:
     *  - language (string): codice iso della lingua corrente
     *  - environment (string): Ambiente corrente (es. 'local', 'testing', 'production')
     *  - pageView (string): Nome della view usata nella pagina (es. 'page_news')
     *  - singleView (string): Nome della view usata per i singolo articoli della pagina (es. 'page_news_single')
     *  - isArticle (bool): True se la pagina corrente è un articolo singolo.
     */
    run(conf) {
        this.config = conf;

        this.debug = conf.environment === 'local';
        this.lang.currentLang = conf.language;
        this.router.start(this, conf.pageView, conf.singleView, conf.isArticle);

        if (this.config.environment === 'production') {
            // Nascondo componenti
            this.components = undefined;
        }
    }
}


/** WEBPACK FOOTER **
 ** ./assets/scripts/src/core/app.js
 **/